// @flow

import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold, fontNormal } from "@fdr/static-ui/Typography";

export const ImageWrapper = styled.div`
  background-color: ${buildColor("grey", "000")};
  width: 100%;
  border-bottom: 1px solid ${buildColor("grey", "300")};
`;

export const DescriptionContainer = styled.div`
  padding: 16px;
  background-color: ${buildColor("white", "100")};
  line-height: 125%;
`;

export const Description = styled.span`
  font-size: 14px;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "900")};

  & > span[data-css="bold"] {
    font-family: ${fontBold};
    color: ${buildColor("navy", "900")};
  }
`;

export const NotApplicableContainer = styled.div`
  margin-top: 16px;
`;

export const TipContainer = styled.div`
  padding-top: 16px;
`;

export const TipTitle = styled.h1`
  font-size: 14px;
  font-family: ${fontBold};
  color: ${buildColor("grey", "900")};
`;

export const Tip = styled.span`
  font-size: 14px;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "900")};
`;

export const TutorialList = styled.ol`
  list-style: none;
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("white", "100")};
  padding: 16px;

  & > li:not(:last-child) {
    padding-bottom: 20px;
  }
`;

export const ListItem = styled.li`
  display: flex;
`;

export const ListNumber = styled.div`
  padding: 0;
`;

export const ListDescription = styled.span`
  padding-left: 12px;
  color: ${buildColor("grey", "900")};
  font-size: 14px;
  font-family: ${fontNormal};
  line-height: 125%;
`;

export const BetInfoList = styled.ul`
  list-style: none;
  background-color: ${buildColor("white", "100")};
`;
